
import { WOW } from "wowjs";

(function ($) {
	$(document).ready(function () {

		const wow = new WOW();

		wow.init();

		$(".menu-item-has-children").find(".dropdown-toggle").attr("data-toggle", "");

		let body = $( 'body' );
		let desktopMenuBreakpoint = parseInt($(":root").css("--desktop-menu-breakpoint"));

		/**
		 * Carousel - Set equal heights
		 */
		function carouselEqualHeights() {
			$('.carousel-block').each(function () {
				var items 		= $('.carousel-item', this);
				let maxHeight 	= 0;

				// Show all slides
				$.each( items, function( i, slide ) {
					$( slide ).addClass( 'active' );
				});

				// Get the height of the tallest caption and save it
				// Desktop
				console.log(window.innerWidth);
				if(window.innerWidth >= 1300) {
					$.each( items, function() {
						let caption 		= $(this);
						let captionHeight 	= caption.css('height', 'auto').outerHeight();

						if ( captionHeight > maxHeight ) {
							maxHeight = captionHeight;
						}
					});

					// Apply the max height to all captions
					$.each( items, function() {
						let caption = $(this);
						caption.css('height', maxHeight);

						// Remove .active from all slides
						$( this ).removeClass( 'active' );
					});
				} else {
					$.each( items, function() {
						let caption 		= $(this);
						let captionHeight 	= caption.css('height', 'auto').outerHeight();

						if ( captionHeight > maxHeight ) {
							maxHeight = captionHeight;
						}
					});

					// Apply the max height to all captions
					$.each( items, function() {
						let caption = $(this);
						caption.css('height', maxHeight);

						// Remove .active from all slides
						$( this ).removeClass( 'active' );
					});
				}

				// Add the active class back to the first slide
				$('.carousel-block .carousel-inner .carousel-item:first-of-type').addClass('active');
			});
		}

		// Run equal heights
		carouselEqualHeights();

		/**
		 * Alert Bar - Header spacing accommodation
		 */
		function alertSpacing() {
			if (! $(body).hasClass('alert-hidden')) {
				let alertBarHeight = $('#alert-system').outerHeight();
				let headerHeight = $('header').outerHeight();

				$('header').css('padding-top', alertBarHeight - 7);
				$('#content').css('padding-top', alertBarHeight + headerHeight);

			} else {
				let headerHeight = $('header').outerHeight();
				$('#content').css('padding-top', headerHeight);
			}
		}
		alertSpacing();

		$(window).resize(function () {
			alertSpacing();
		});

		/**
		 * Form - Add custom checkbox element
		 */
		$( '.ginput_container_checkbox .gfield_checkbox .gchoice' ).addClass('checkbox_item').append('<div class="checkmark"></div>');
		$( '.ginput_container_radio .gfield_radio .gchoice' ).addClass('radio_item').append('<div class="radio"></div>');


		/**
		 * Add class to body when sticky header is showing
		 */
		if ($(window).scrollTop() > 50){
			body.addClass('sticky-header');
			$('header').addClass('sticky');
		} else {
			body.removeClass('sticky-header');
			$('header').removeClass('sticky');
		}
		$(window).scroll(function(){
			if ($(window).scrollTop() > 50){
				$('body').addClass('sticky-header');
				$('header').addClass('sticky');
			} else {
				$('body').removeClass('sticky-header');
				$('header').removeClass('sticky');
			}
		});

		/**
		 * Back to top button - scroll functionality
		 */
		$("#back-to-top").on("click", function(){
			$("html, body").animate({
				scrollTop: 0,
			}, 400);

			return false;
		});

		/**
		 * Mobile menu
		 */

		$("header .js-mobile-menu-toggle").on("click", function(){
			$("body").toggleClass("no-scroll");
		});

		$("#header-navbar-menu-wrapper")
			.find(".navbar-nav .menu-item.menu-item-has-children > .dropdown-menu").each(function(){

			if($(window).width() < desktopMenuBreakpoint){

				$(this).addClass("mobile-menu-sub-level-panel");

				let subLevelTitleElement = $("<h4>").html($(this).siblings(".nav-link").html().trim());

				$(this).prepend(
					$("<li>")
						.addClass("menu-item sub-level-panel-heading")
						.append(subLevelTitleElement)
				);

			}

		});

		$("#header-navbar-menu-wrapper.navbar-collapse")
			.on("show.bs.collapse", function(){

				let headerBannerHeight = 0;

				$("body > header").children().each(function(){
					headerBannerHeight += $(this).outerHeight();
				});

				if(!$("body > header").hasClass("sticky")){
					headerBannerHeight += (parseInt($("html").css("margin-top")) - $("html").scrollTop());
				}

				$(this).css("--mobile-menu-height", ($(window).outerHeight() - headerBannerHeight) + "px");

				$(this).children(".header-navbar-menu-inner-wrap").addClass("curr-level");

			})
			.on("hidden.bs.collapse", function(){

				$(this).find(".curr-level").removeClass("curr-level");

				$(this).find(".show").removeClass("show fade-in");

				$(this).find(".mobile-menu-sub-level-panel").scrollTop(0);

				$(this).find(".js-menu-back-btn").data("depth-level", 0);

			});

		let mobileMenuBackBtnWrap = $("#header-navbar-menu-wrapper").find(".back-btn-wrap");
		let mobileMenuBackBtn = mobileMenuBackBtnWrap.children(".js-menu-back-btn");

		mobileMenuBackBtn.data("depth-level", 0);

		mobileMenuBackBtn.on("click", function(){

			$(this).data("depth-level", ($(this).data("depth-level") - 1));

			let currentMenuPanel = $("#header-navbar-menu-wrapper").find(".mobile-menu-sub-level-panel.curr-level");

			currentMenuPanel.parent().closest(".mobile-menu-sub-level-panel").addClass("curr-level");

			currentMenuPanel.addClass("fade-out").removeClass("show fade-in curr-level");

			if($(this).data("depth-level") <= 0){

				$("#header-navbar-menu-wrapper").find(".header-navbar-menu-inner-wrap").addClass("curr-level");

				$(this)
					.data("depth-level", 0)
					.parent()
					.addClass("fade-out")
					.removeClass("show fade-in");

			}

		});

		$("#header-navbar-menu-wrapper").find(".navbar-nav .menu-item.menu-item-has-children > .nav-link")
			.on("click", function (evt) {

				evt.preventDefault();

				$("#header-navbar-menu-wrapper").find(".curr-level").removeClass("curr-level");

				$(this).siblings(".mobile-menu-sub-level-panel")
					.scrollTop(0)
					.removeClass("fade-out")
					.addClass("show fade-in curr-level");

				if(window.innerWidth < 992) {
					if (mobileMenuBackBtn.data("depth-level") === 0) {

						mobileMenuBackBtnWrap
							.removeClass("fade-out")
							.addClass("show fade-in");
					} else {

						$(this).siblings(".mobile-menu-sub-level-panel")
							.css("top", $(this).closest(".mobile-menu-sub-level-panel, .header-navbar-menu-inner-wrap").scrollTop());

					}
				}

				mobileMenuBackBtn.data("depth-level", (mobileMenuBackBtn.data("depth-level") + 1));

				return false;

			});

	});
})(jQuery);